import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";

export const UsersLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListUsers') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateUser') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/users'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetUser') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/users'/>
                    )
                }
            />
        </Routes>
    );
};
